import { render } from "./productBoxWide.vue?vue&type=template&id=cfff6788&ts=true"
import script from "./productBoxWide.vue?vue&type=script&lang=ts"
export * from "./productBoxWide.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__